<template>
  <div>
    <Header/>
    <Sidebar/>
    <Content/>
    
  </div>
</template>

<script>
import Header from '@/components/Header'
import Sidebar from '@/components/Sidebar'
import Content from '@/components/Content'
export default{
  middleware: 'auth',
  components:{
    Header,
    Sidebar,
    Content
  }
}
</script>


